import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { AuthCallback } from "./components/AuthCallback";
import { FullScreenLoader } from "./components/FullScreenLoader";
import AuthPage from "./pages/AuthPage";
import SharePage from "./pages/SharePage";
import Workspace from "./pages/Workspace";
import PaymentCallback from "./pages/PaymentCallback";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import SchoolPage from "./pages/SchoolPage";
import PrivacyPage from "./pages/PrivacyPage";
import DeleteAccountPage from "./pages/DeleteAccountPage";
import TesterPage from "./pages/TesterPage";
import AccountPage from "./pages/AccountPage";
import AdminTestersPage from "./pages/AdminTestersPage";
import PlayListingPage from "./pages/PlayListingPage";

const Protected = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <FullScreenLoader />;
  if (user === false) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<AuthPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/delete-account" element={<DeleteAccountPage />} />
      <Route path="/testers" element={<TesterPage />} />
      <Route path="/account" element={<Protected><AccountPage /></Protected>} />
      <Route path="/admin/testers" element={<Protected><AdminTestersPage /></Protected>} />
      <Route path="/play-listing" element={<Protected><PlayListingPage /></Protected>} />
      <Route path="/s/:shareId" element={<SharePage />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/school" element={<Protected><SchoolPage /></Protected>} />
      <Route path="/payment/callback" element={<Protected><PaymentCallback /></Protected>} />
      <Route path="/" element={<Protected><Workspace /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster theme="dark" position="top-right" />
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
